import { render, staticRenderFns } from "./ProductEditPriceRules.vue?vue&type=template&id=1267b31f"
import script from "./ProductEditPriceRules.vue?vue&type=script&lang=ts"
export * from "./ProductEditPriceRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports